import { useEffect } from 'react';
import { useRouter } from 'next/router';
import AppShell from '@/components/layouts/AppShell';
import { PageWithLayout } from '@/types/AppWithLayout';
import CaireHead from '@/components/CaireHead';

const ProviderSearchPage: PageWithLayout = () => {
  const router = useRouter();

  useEffect(() => {
    const { query } = router;
    router.replace({
      pathname: '/provider-search/home',
      query,
    });
  }, [router]);

  return <CaireHead title="Provider Search" />;
};

ProviderSearchPage.getLayout = (page) => {
  return <AppShell withNavigation={false}>{page}</AppShell>;
};

export default ProviderSearchPage;
